/* eslint-disable */
// istanbul ignore file
import React, { type Dispatch, useState } from 'react'
import { Grid, CardContent, IconButton, CircularProgress } from '@mui/material'
import DefaultImage from '../../../assets/No-Image.png'
import LanguageStrings from '../../../i18n/locales'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { useNavigate } from 'react-router-dom'
import { siteDeleteCampaign } from '../../site-management/redux/actionCreators'
import { connect, type ConnectedProps, useSelector } from 'react-redux'
import type { RootState } from '../../../store'
import GenericModal from '../../../components/Modal'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { APIConfiguration } from '../../../utils/apiConfiguration'
import moment from 'moment-timezone'
import { Tooltip } from '@mui/material'

const SiteInformationStrings = LanguageStrings().AssetManagementCollectionStrings.SiteInformationComponent
const httpStatus = APIConfiguration

const SiteInformation = (props: PropsFromRedux & { siteInfo: any, imageBinaryData: any }): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const navigate = useNavigate()
  const [selectedSiteId, setSelectedSiteId] = React.useState('')
  const [selectedSiteName, setSelectedSiteName] = React.useState('')
  const [confirmDeletePopup, setConfirmDeletePopup] = React.useState(false)
  const [showDeleteStatus, setShowDeleteStatus] = React.useState(false)
  const siteDeleteStatus = useSelector(
    (state: RootState) => state.siteDeleteState
  )
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }
  const handleEdit = (): void => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    navigate(`/edit-site/${props.siteInfo.siteInfo.id}`)
  }

  const handleDelete = (): void => {
    setSelectedSiteId(props.siteInfo.siteInfo.id)
    setSelectedSiteName(props.siteInfo.siteInfo.name)
    setConfirmDeletePopup(true)
    setAnchorEl(null)
  }

  const handleDeleteCampaign = (): void => {
    setConfirmDeletePopup(false)
    setShowDeleteStatus(true)
    props.siteDeleteCampaign(selectedSiteId, selectedSiteName)
  }

  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 40) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 40)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : '-'}</span>
  }

  const handleDeleteCampaignWithFailure = (): JSX.Element => {
    /* istanbul ignore next */
    if (siteDeleteStatus.httpStatus === httpStatus.SUCCESS_HTTP_STATUS) {
      return (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={SiteInformationStrings.successfullyDeleted}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
            navigate('/site-list') // Redirect to /site-list after closing the modal
          }}
          onClose={() => {
            setShowDeleteStatus(false)
            navigate('/site-list') // Redirect to /site-list after closing the modal
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {SiteInformationStrings.FullMsgSiteDeletedSuccessfully}
          </p>
        </GenericModal>
      )
    } else if (siteDeleteStatus.isLoading) {
      return (
        <GenericModal title={'Loading...'}>
          <div className="CircularprogressAmi">
            <CircularProgress />
          </div>
        </GenericModal>
      )
    } else if (siteDeleteStatus.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {siteDeleteStatus.error} </p>
        </GenericModal>
      )
    } else if (siteDeleteStatus.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="Unauthorized" />
        </div>
      )
    } else if (siteDeleteStatus.httpStatus === httpStatus.ACCESS_FORBIDDEN_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="accessForbidden" />
        </div>
      )
    } else {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {siteDeleteStatus.error} </p>
        </GenericModal>
      )
    }
  }
  
  return (
    <>
      <CardContent style={{ padding: '0px' }}>
        <Grid container>
          <Grid xs={12} sm={1}>
            <div style={{ padding: '10px', backgroundColor: '#303030', height: 'fit-content', borderRadius: '10px', width: 'fit-content' }}>
              <img
                src={props.imageBinaryData && props.imageBinaryData.binaryData
                  ? `data:image/jpeg;base64,${props.imageBinaryData.binaryData}`
                  : DefaultImage}
                alt="Preview" style={{width: '136px', height: '136px'}}
              />
            </div>
          </Grid>
          <Grid container xs={12} sm={11} style={{ paddingLeft: '32px' }}>
            <Grid item xs={12} sm={12}>
              <Grid>
                <span style={{fontSize: 'small', fontWeight: '600'}}>
                  {SiteInformationStrings.SiteInformation}
                </span>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={3}>
                <Grid>{SiteInformationStrings.Name}</Grid>
                <Grid>{props?.siteInfo?.siteInfo?.siteName}</Grid>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid>{SiteInformationStrings.CreatedOn}</Grid>
                <Grid>
                  {props?.siteInfo?.siteInfo !== null && props?.siteInfo?.siteInfo?.install_date !== null && props?.siteInfo?.siteInfo?.install_date !== '' ? moment.utc(props?.siteInfo?.siteInfo?.install_date).tz(userTimezone).format('hh:mm A, MMM DD YYYY') : ''}
                </Grid>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid>{SiteInformationStrings.Description}</Grid>
                <Grid>{formatTextWithTooltip(props?.siteInfo?.siteInfo?.description)}</Grid>
              </Grid>
              <Grid item xs={12} sm={3} style={{ marginLeft: 'auto', position: 'relative' }}>
                <IconButton
                  aria-haspopup="true"
                  aria-controls={open ? 'fade-menu' : undefined}
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                  sx={{ padding: '0px !important', position: 'absolute', top: 0, right: 0 }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="fade-menu"
                  MenuListProps={{ 'aria-labelledby': 'fade-button' }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleEdit} style={{ color: '#64c3ff', textDecoration: 'none' }}>Edit</MenuItem>
                  <MenuItem onClick={handleDelete} style={{ color: '#64c3ff', textDecoration: 'none' }}>Delete</MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      {confirmDeletePopup && (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={'Delete Site'}
          LabelPositive="Confirm"
          LabelNegative="Cancel"
          onClickPositive={handleDeleteCampaign}
          onClose={() => { setConfirmDeletePopup(false) }}
          onClickNegative={() => { setConfirmDeletePopup(false) }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {SiteInformationStrings.DeleteConfirmation}<br/><br/>
            {SiteInformationStrings.DeleteConfirmationWarning}
          </p>
        </GenericModal>
      )}
        {
            /* istanbul ignore next */
            showDeleteStatus && handleDeleteCampaignWithFailure()
        }
    </>
  )
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  siteDeleteCampaign: (selectedAssetId: string, selectedAssetName: string) => { dispatch(siteDeleteCampaign(selectedAssetId, selectedAssetName)) }
})

const connector = connect(null, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(SiteInformation)
